import tokens from '@lansforsakringar/core-tokens'
import { css } from 'lit'

import { scoped, declare, vars } from '#utils/styles'

export const locals = scoped('icon', [
	'color',
	'size',
	'internal_size'
] as const)

export default css`
	:host {
		${declare(locals, {
			color: tokens.color_icon_primary
		})};

		display: inline-block;
		vertical-align: middle;
		line-height: 1;
	}

	.icon {
		--icon-size-factor: calc(${vars(locals.size, locals.internal_size)} / 16);
		display: block;
		font-size: inherit;
		width: calc(var(--icon-size-factor) * 1em);
		height: calc(var(--icon-size-factor) * 1em);
		color: ${vars(locals.color)};
		user-select: none;
	}

	.icon svg {
		display: block;
		width: 100%;
		height: 100%;
		min-width: 100%;
		min-height: 100%;
		max-width: none;
		max-height: none;
	}
`
